<div *ngIf="enableTab" class="widget" [class.loading-widget]="loading" [class.widget--no-data]="noData">
    <span class="widget__title" *ngIf="!isInPopup">
        <span>{{'Inspections due' | translate | async}}</span>      
        <i class="material-icons" [matTooltip]="'Inspections are due by today\'s date. This is based on what you searched for in total and not what you see in this page only. ' | translate | async">info</i>
        <i class="material-icons" [matTooltip]="'Enlarge ' | translate | async | translate | async" (click)="openWithANewPopup()">zoom_in</i>
    </span>
    <div [ngClass]="{'widget__content' : !isInPopup , 'large-widget' : isInPopup}">
        <div class="spinner-container" *ngIf="loading">
            <mat-spinner></mat-spinner>
        </div>
        <fusioncharts *ngIf="!loading" [hidden]="loading" [id]="chartid" [width]="width" [height]="height" [type]="type"
            [dataFormat]="dataFormat" [dataSource]="dataSource"></fusioncharts>
    </div>
    <div class="widget__no-data" *ngIf="noData">
        <span>{{'You don\'t have any inspection due for the selection. ' | translate | async}}</span>
    </div>
</div>